export const getHeadings = (step: 1 | 2 | 3, isEmail: boolean, isEdit?: boolean, isBackupEmail?: boolean) => {
  switch (step) {
    case 1:
      return {
        title: `${isEdit ? 'change' : 'add'}${isEmail ? (isBackupEmail ? ' backup email' : ' email') : ' phone'}`,
        subtitle: isBackupEmail ? 'email_required_to_disable_2fa' : 'access_account_convinient',
      }
    case 2:
      return { title: 'secure_verification', subtitle: 'verify_identity' }
    case 3:
      return {
        title: 'security_verification',
        subtitle: 'to_secure_account_complete_verification',
      }
    default:
      return { title: '', subtitle: '' }
  }
}
